import ResponsiveTable from '../ReusableComponents/ResponsiveTable';
import StatusBadge from '../ReusableComponents/StatusBadge';
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdArrowDownward, MdArrowUpward, MdDelete, MdDoubleArrow, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';
import { API_URL, URL } from "../../variables";
import ModalRespostas from "./ModalRespostas";
import { Form, FormControl as Input, InputGroup, Select, Spinner } from "react-bootstrap";
import { SwapVert } from "@material-ui/icons";
import { getNumeroInscricaoProcesso } from "../../Auxiliar/Inscricao";
import "../Faculdades/Dashboard/Cards/DashboardReports.css";


var pesquisarTimeout = null;

const ResultadosProva = props => {

    const [lesson_cards, SetLessonCards] = useState(null);
    const [loading_screen, setLoadingScreen] = useState(true);
    const [loading_zip, setLoadingZip] = useState(false);

    const [loading_provas, setLoadingprovas] = useState(false);
    const [search_oficial, setSearchOficial] = useState('');
    const [message_zip, setMessageZip] = useState('');


    const [message_zip2, setMessageZip2] = useState('');
    const [loading_zip2, setLoadingZip2] = useState(false);


    const [message_zip3, setMessageZip3] = useState('');
    const [loading_zip3, setLoadingZip3] = useState(false);


    const [provas, setprovas] = useState([]);
    const [orderBy, setOrderBy] = useState('users.name');
    const [orderType, setOrderType] = useState('desc');



    const [questoes, setquestoes] = useState([]);

    const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



    const [search, setSearch] = useState('');
    const { prova, prova_id, prova_name, processo_id, processo_name, prova_type, models } = props;
    const [show_warning, setShowWarning] = useState(false);
    const [provas_id, setRedacaoId] = useState(null);
    console.log('models', models)

    const [questaoSelect, setQuestaoSelect] = useState({});

    const [provaSelect, setProvaSelect] = useState(null);
    const [model_value, setModelValue] = useState('all');


    const [showModal, setShowModal] = useState(false);
    const [loadingDetailId, setLoadingDetailId] = useState(null);
    const [detailError, setDetailError] = useState("");
    let refs = [];
    const dispatch = useDispatch();
    const timerRef = useRef(null);
    const timerRefZip = useRef(null);


    const Getprovas = async (page, search, value, orderby = orderBy, ordertype = orderType) => {

        let response = await Request.Get(`faculdade/get_resultados_prova/${prova_id}?page=${page}&search=${search}&model=${value}&orderby=${orderby}&ordertype=${ordertype}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        if (response.pagination.current_page == page) {

            setprovas(response.provas);

            if (prova.random_layouts_max == false) {
                setquestoes(response.questoes);
            }



            setPagination(response.pagination);
            setLoadingScreen(false);
            setLoadingprovas(false);


        }
    }

    const openResultDetail = async item => {
        setLoadingDetailId(item.id);
        setDetailError("");
        const response = await Request.Get(`faculdade/get_resultado_prova_detail/${item.id}`);
        setLoadingDetailId(null);
        if (response === undefined) {
            setDetailError("Não foi possível carregar as respostas.");
            return;
        }
        if (response.message === 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        if (response.errors) {
            setDetailError(response.errors.error || "Não foi possível carregar as respostas.");
            return;
        }
        setquestoes(response.questoes || []);
        setProvaSelect(response.resultado);
        setShowModal(true);
    };


    const GetProvasPdfRespostaZip = async () => {

        let response = await Request.Get(`faculdade/get_respostas_prova_pdf/${prova_id}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        // else if(response['status']==undefined){
        //     setLoadingZip(false);

        //     saveAs(response,'redacoes_processo_'+processo_name+'.zip');
        // }
        else {
            if (response['status'] == true) {
                document.getElementById('download_link').href = response['path'];
                document.getElementById('download_link').click();
                setLoadingZip3(false);
                setMessageZip3('');

                return;
            }
            else if (response['status'] != 'Error') {
                setMessageZip3(response['message']);
            }
            timerRef.current = setTimeout(() => {
                GetProvasPdfRespostaZip();
            }, 20000);

        }


    }


    const GetProvasPdfZip = async () => {

        let response = await Request.Get(`faculdade/download_provas/${prova_id}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        // else if(response['status']==undefined){
        //     setLoadingZip(false);

        //     saveAs(response,'redacoes_processo_'+processo_name+'.zip');
        // }
        else {
            if (response['status'] == true) {
                document.getElementById('download_link').href = response['path'];
                document.getElementById('download_link').click();
                setLoadingZip(false);
                setMessageZip('');

                return;
            }
            else if (response['status'] != 'Error') {
                setMessageZip(response['message']);
            }
            timerRef.current = setTimeout(() => {
                GetProvasPdfZip();
            }, 20000);

        }


    }




    const GetProvassZip = async () => {

        let response = await Request.Get(`faculdade/get_respostas_prova/${prova_id}`);
        console.log(response);
        if (response === undefined) return;
        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        // else if(response['status']==undefined){
        //     setLoadingZip(false);

        //     saveAs(response,'provas_processo_'+processo_name+'.zip');
        // }
        else {
            // setLoadingZip(false);
            // setMessageZip('');


            if (response['status'] == true) {
                document.getElementById('download_link').href = response['path'];
                document.getElementById('download_link').click();
                setLoadingZip2(false);
                setMessageZip2('');

                return;
            }
            else if (response['status'] != 'Error') {
                setMessageZip2(response['message']);
            }
            timerRefZip.current = setTimeout(() => {
                GetProvassZip();
            }, 20000);


        }


    }

    const DeleteRedacao = async (provas_id) => {

        let response = await Request.Delete(`faculdade/desvincular_prova/${provas_id}`);
        console.log(response);
        if (response === undefined) return;

        if (response['message'] == 'Unauthenticated.') {
            dispatch(logout());
            return;
        }
        Getprovas(pagination.current_page, search_oficial, model_value);



    }

    useEffect(() => {
        Getprovas(1, search_oficial, model_value);

        return () => {
            clearTimeout(timerRef.current)
            clearTimeout(timerRefZip.current)

        }
    }, []);

    const changeOrder = (column) => {
        if(loading_provas==true){
            return;
        }
        let orderby = '', ordertype = 'desc';
        if (orderBy == column) {
            orderby = column;
            if (orderType == 'desc') {
                setOrderType('asc');
                ordertype = 'asc';
            }
            else if (orderType == 'asc') {
                setOrderType('desc');
                orderby='resultados.created_at'
                setOrderBy('resultados.created_at');
            }
        }
        else {
            setOrderBy(column);
            setOrderType('desc');
        }
        orderby = column;
        setLoadingprovas(true);
        Getprovas(pagination.current_page, search_oficial, model_value, orderby, ordertype)
    }

    const renderIcon = (column)=>{
        return <div style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                changeOrder(column);
                                            }}
                                        >
                                           {(orderBy == column && orderType == 'desc') ? <MdArrowUpward />
            : (orderBy == column && orderType == 'asc' ? <MdArrowDownward /> : <SwapVert />)}
                                        </div>
         
    }

    const history = useHistory();
    return (
        <div className="row">

            <div className="col-12">

                <a id="download_link" target="_blank"></a>

                {/* <hr /> */}
                {loading_screen == false && <div>


                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}
                    <ModalRespostas showModal={showModal} setShowModal={(e) => { setShowModal(e); setProvaSelect(null) }} provaSelect={provaSelect} prova_name={prova_name} questoes={questoes} />
                    {detailError && <p className="text-danger">{detailError}</p>}
                    <a id="download_link" target="_blank"></a>
                    <div className="row">



                        <Search className="mt-1" children={<Form.Label>Pesquisa </Form.Label>} style={{ flexBasis: 'none' }} placeholder="Pesquisar pelo nome/cpf/número de inscrição do candidato" ValueChange={value => {
                            clearTimeout(pesquisarTimeout);
                            setSearchOficial(value);

                            pesquisarTimeout = setTimeout(() => {
                                let page = { ...pagination };
                                page.current_page = 1;
                                setPagination(pagination);
                                setLoadingprovas(true);

                                Getprovas(1, value, model_value)

                            }, 500);
                        }} />
                        <div className="col-12 col-md-6">

                            <div style={{ width: '100%' }} className="mt-1">
                                <InputGroup>
                                    <div className="flex fdcolumn flex1 margin-bottom">
                                        <Form.Label>Modelo </Form.Label>
                                        <select style={{ height: 45 }} className="form-select " onChange={(e) => {
                                            let page = { ...pagination };
                                            page.current_page = 1;
                                            setPagination(pagination);
                                            setLoadingprovas(true);
                                            setModelValue(e.target.value);
                                            Getprovas(1, search_oficial, e.target.value)

                                        }} value={model_value}>
                                            <option
                                                value={'all'}
                                            >{'Todos'}</option>
                                            {models.map((item) => <option
                                                value={item.id}
                                            >{item.name}</option>)}
                                        </select>
                                    </div>
                                </InputGroup>
                            </div>
                        </div>

                    </div>

                    <div className="flex justify-content-end flex-wrap mb-4">

                        <div className=" mt-2" style={{
                            height: 'max-content',
                            justifyContent: 'flex-end'
                        }}>
                            <div className="d-flex " style={{
                                justifyContent: 'flex-end'
                            }}>

                                {/* {<span onClick={() => {
                                   
                                        GetProvassZip();
                                   
                                }} style={{ textDecoration: "none", marginRight:5 }}>
                                    {<Button variant="success" className="flex align-center jcc"><MdFileDownload style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Baixar respostas da prova</p></Button>}

                                </span>} */}

                                

                                {loading_zip2 == false && <span onClick={() => {
                                    if (loading_zip2 == false) {
                                        setLoadingZip2(true);
                                        setMessageZip2('Criando .zip para download');
                                        GetProvassZip();
                                    }
                                    else {

                                    }
                                }} style={{ textDecoration: "none", marginRight: 5 }}>
                                    {<Button variant="success" className="flex align-center jcc"><MdFileDownload style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Baixar respostas da prova</p></Button>}

                                </span>}
                                {loading_zip2 == true && <div style={{ flexBasis: "50%", paddingLeft: 10, paddingRight: 10 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress size={15} />
                                </div>
                                    <div className="col-12 d-flex justify-content-center align-items-center">
                                        <p style={{ marginBottom: 0, textAlign: 'center', fontSize: 13, color: 'darkgoldenrod' }}>{message_zip2}</p>
                                    </div>
                                </div>}
                                

                                {prova_type == 'multipla_escolha' && loading_zip == false && <span onClick={() => {
                                    if (loading_zip == false) {
                                        setLoadingZip(true);
                                        setMessageZip('Criando .zip para download');
                                        GetProvasPdfZip();
                                    }
                                    else {

                                    }
                                }} style={{ textDecoration: "none",marginRight: 5 }}>
                                    {<Button variant="success" className="flex align-center jcc"><MdFileDownload style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Baixar folhas de resposta em .pdf</p></Button>}

                                </span>}
                                {loading_zip == true && <div style={{ flexBasis: "50%", paddingLeft: 10, paddingRight: 10 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress size={15} />
                                </div>
                                    <div className="col-12 d-flex justify-content-center align-items-center">
                                        <p style={{ marginBottom: 0, textAlign: 'center', fontSize: 13, color: 'darkgoldenrod' }}>{message_zip}</p>
                                    </div>
                                </div>}


                                {loading_zip3 == false && <span onClick={() => {
                                    if (loading_zip3 == false) {
                                        setLoadingZip3(true);
                                        setMessageZip3('Criando .zip para download');
                                        GetProvasPdfRespostaZip();
                                    }
                                    else {

                                    }
                                }} style={{ textDecoration: "none", marginRight: 5 }}>
                                    {<Button variant="success" className="flex align-center jcc"><MdFileDownload style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Baixar caderno com respostas em pdf</p></Button>}

                                </span>}
                                {loading_zip3 == true && <div style={{ flexBasis: "50%", paddingLeft: 10, paddingRight: 10 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress size={15} />
                                </div>
                                    <div className="col-12 d-flex justify-content-center align-items-center">
                                        <p style={{ marginBottom: 0, textAlign: 'center', fontSize: 13, color: 'darkgoldenrod' }}>{message_zip3}</p>
                                    </div>
                                </div>}

                            </div>


                        </div>


                    </div>

                    <div className="table-rep-plugin">
                        <div className="table-responsive mb-0" data-pattern="priority-columns">
                            <ResponsiveTable id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>
                                        <th ><div style={{ display: 'flex' }}>Nome {renderIcon('users.name')}</div></th>
                                        <th ><div style={{ display: 'flex' }}>E-mail {renderIcon('users.email')}</div></th>
                                        <th><div style={{ display: 'flex' }}>CPF {renderIcon('users.cpf')}</div></th>
                                        <th><div style={{ display: 'flex' }}>Número de Inscrição {renderIcon('users.numero_inscricao')}</div></th>
                                        <th><div style={{ display: 'flex' }}>Status</div></th>
                                        <th><div style={{ display: 'flex' }}>Modelo  {renderIcon('provas.code_exam')}</div></th>
                                        <th><div style={{ display: 'flex' }}>Resultado {renderIcon('resultados.acertou')}</div></th>
                                        <th className="hidethis" data-priority="3">Ações</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_provas == false && provas.map((item, id) => (

                                        <tr key={id}>
                                            <td>{item.user.name}</td>
                                            <td>{item.user.email}</td>
                                            <td>{item.user.cpf}</td>
                                            <td>{getNumeroInscricaoProcesso(item.user, processo_id)}</td>
                                            {item.processo_resultado?.status == 'F' && <td><StatusBadge variant="success">{'Finalizado'}</StatusBadge></td>}
                                            {item.processo_resultado?.status != 'F' && <td><StatusBadge variant="warning">{'Não Finalizado'}</StatusBadge></td>}

                                            <td>{item?.prova?.code_exam ?? '-'}</td>
                                            <td>
                                                <div className="dashboard-result-summary">
                                                    <span className="dashboard-report-badge success">Acertos: {item?.acertou ?? '-'}</span>
                                                    <span className="dashboard-report-badge info">Nota: {item?.nota != null ? Number(item?.nota).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }) : '-'}</span>
                                                    <span className="dashboard-report-badge danger">Erros: {item?.erros ?? '-'}</span>
                                                    <span className="dashboard-report-badge warning">Em branco: {item?.em_branco ?? '-'}</span>
                                                </div>
                                            </td>




                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}

                                            <td className="hidethis">

                                                <span
                                                    onClick={() => openResultDetail(item)}
                                                    className="inline-flex align-center jcc bg-warning icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Ver respostas"
                                                >
                                                    {loadingDetailId === item.id ? <CircularProgress size={16} /> : <BsFillEyeFill size={17} color="white" />}
                                                </span>
                                                {/* <span
                                                    onClick={() => {
                                                        GetVideoCandidato(item);

                                                    }}
                                                    className="inline-flex align-center jcc bg-success icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Baixar Vídeo"
                                                >
                                                    <MdVideoLibrary size={17} color="white" />
                                                </span> */}
                                                {/* <Link to={`/provas_vinculados/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                                                    <span
                                                        className="inline-flex align-center jcc bg-info icon"
                                                        style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                                                        data-toggle="tooltip"
                                                        title="Editar questão"
                                                    >
                                                        <MdModeEdit color="white" size={17} />
                                                    </span>
                                                </Link> */}
                                                {/* <span
                                                    onClick={(e) => {
                                                        setRedacaoId(item.id);
                                                        setShowWarning(true);
                                                        e.stopPropagation();
                                                    }}
                                                    className="inline-flex align-center jcc bg-danger icon"
                                                    style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                                                    title="Desvincular provas"
                                                >
                                                    <MdDelete size={17} color="white" />
                                                </span> */}
                                            </td>

                                        </tr>
                                    ))}

                                </tbody>
                            </ResponsiveTable>
                            {loading_provas == true &&
                                <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                                    </div> */}
                                    <CircularProgress />
                                </div></div>

                            }
                        </div>
                    </div>
                    {loading_provas == false && provas.length == 0 && <div className="row w-100">
                        <div className="col-12">
                            <p style={{ textAlign: 'center' }}>Nenhuma prova encontrada</p>

                        </div>
                    </div>}

                    <Pagination
                        className={(pagination.last_page == 1 ? "hide" : "") + " hidethis"}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        count={pagination.last_page}
                        value={pagination.current_page}
                        onChange={(_, value) => {
                            setLoadingprovas(true);
                            console.log(_, value);
                            let page = { ...pagination };
                            page.current_page = value;
                            setPagination(pagination);
                            Getprovas(value, search_oficial, model_value)
                        }}
                    />

                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_provas={this.get_provas.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
                    warning
                    title={"Atenção"}
                    onConfirm={() => {
                        setShowWarning(false);
                        setLoadingprovas(true);
                        DeleteRedacao(provas_id);
                        // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                        setShowWarning(false);
                    }}
                    show={show_warning}
                    confirmBtnText='Sim, desejo desvincular'
                    cancelBtnText='Cancelar'
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                >
                    Ao desvincular este prova, ele não terá mais acesso a este processo
                </SweetAlert>


            </div>

        </div>
    )
}

export default ResultadosProva;
